/** Listen und Eintraege live aus der Datenbank (F-33). */
import { useLiveQuery } from 'dexie-react-hooks';

import { db } from '@/db/schema';
import type { Liste, ListenEintrag } from '@/domain/listen/typen';
import type { ID } from '@/domain/types';

/** Alle Listen in ihrer Reihenfolge - archivierte inklusive. */
export function useAlleListen(): Liste[] | undefined {
  return useLiveQuery(() => db.listen.orderBy('order').toArray(), []);
}

export function useListe(id: ID | undefined): Liste | null | undefined {
  return useLiveQuery(async () => (id ? (await db.listen.get(id)) ?? null : null), [id]);
}

export function useEintraege(listeId: ID | undefined): ListenEintrag[] {
  return useLiveQuery(() => (listeId ? db.listenEintraege.where('listeId').equals(listeId).toArray() : []), [listeId], []);
}

/** Eintraege aller Listen, nach Liste gruppiert - fuer Uebersicht und Auswertung. */
export function useEintraegeJeListe(): Map<ID, ListenEintrag[]> {
  return useLiveQuery(async () => {
    const m = new Map<ID, ListenEintrag[]>();
    for (const e of await db.listenEintraege.toArray()) m.set(e.listeId, [...(m.get(e.listeId) ?? []), e]);
    return m;
  }, [], new Map());
}
